define(function (require) {
    var $ = require("jquery");
    var ko = require("knockout");
    require("bootstrap-select");

    //https://github.com/silviomoreto/bootstrap-select/issues/200#issuecomment-31185253
    ko.bindingHandlers.selectPicker = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var $el = $(element);
            var isSelect = $el.is("select");
            var isMulti = $el.prop("multiple");

            if (isSelect) {
                if (ko.isObservable(valueAccessor())) {
                    if (isMulti && $.isArray(ko.utils.unwrapObservable(valueAccessor()))) {
                        // in the case of a multiple select where the valueAccessor() is an observableArray, call the default Knockout selectedOptions binding
                        ko.bindingHandlers.selectedOptions.init(element, valueAccessor, allBindingsAccessor);
                    } else {
                        // regular select and observable so call the default value binding
                        //ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor);
                    }
                }
                $(element).addClass("bselect").selectpicker();
            }
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            var $el = $(element);
            var isSelect = $el.is("select");
            var isMulti = isSelect && $el.prop("multiple");

            if (isSelect) {
                var saveValue = null;
                var selectPickerOptions = allBindingsAccessor().selectPickerOptions;
                if (typeof selectPickerOptions !== "undefined" && selectPickerOptions !== null) {
                    var options = selectPickerOptions.optionsArray,
                        optionsText = selectPickerOptions.optionsText,
                        optionsValue = selectPickerOptions.optionsValue,
                        optionsCaption = selectPickerOptions.optionsCaption,
                        isDisabled = selectPickerOptions.disabledCondition || false,
                        resetOnDisabled = selectPickerOptions.resetOnDisabled || false;
                    // call the default Knockout options binding
                    valueAccessor().notifySubscribers = function () {};
                    saveValue = valueAccessor()();
                    ko.bindingHandlers.options.update(element, options, allBindingsAccessor);
                    valueAccessor().notifySubscribers = function () {
                        ko.subscribable.fn.notifySubscribers.apply(this, arguments);
                    };
                    if (isDisabled && resetOnDisabled) {
                        // the dropdown is disabled and we need to reset it to its first option
                        $el.selectpicker("val", $el.children("option:first").val());
                    }
                    $el.prop("disabled", isDisabled);
                }
                if (ko.isObservable(valueAccessor())) {
                    if (isMulti && $.isArray(ko.utils.unwrapObservable(valueAccessor()))) {
                        // in the case of a multiple select where the valueAccessor() is an observableArray, call the default Knockout selectedOptions binding
                        ko.bindingHandlers.selectedOptions.update(element, valueAccessor);
                    } else {
                        // call the default Knockout value binding
                        if (saveValue != null) {
                            valueAccessor().notifySubscribers = function () {};
                            valueAccessor()(saveValue);
                            valueAccessor().notifySubscribers = function () {
                                ko.subscribable.fn.notifySubscribers.apply(this, arguments);
                            };
                        }
                        //ko.bindingHandlers.value.update(element, valueAccessor());
                    }
                }

                $el.selectpicker("refresh");
            }
        }
    };
});
